import { render, staticRenderFns } from "./CardGareTransportView.vue?vue&type=template&id=39bb1cea&scoped=true"
import script from "./CardGareTransportView.vue?vue&type=script&lang=js"
export * from "./CardGareTransportView.vue?vue&type=script&lang=js"
import style0 from "./CardGareTransportView.vue?vue&type=style&index=0&id=39bb1cea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39bb1cea",
  null
  
)

export default component.exports